import * as React from 'react';
import styled from 'styled-components';

const StyledPlaceholder = styled.div`
    background-color: ${props => props.theme.colors.border.divider};
    color: ${props => props.theme.colors.content.secondary};
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

export class ImagePlaceHolderElement extends React.Component<{
    children?: React.ReactNode;
}> {
    public render(): JSX.Element | null {
        const {children} = this.props;

        return <StyledPlaceholder>{children}</StyledPlaceholder>;
    }
}
